<!-- This element is used to initialise the clndr instance -->
<div #el></div>

<!-- This is for the angular based rendering -->
<div class="clndr">
  <!-- Controls -->
  <div class="clndr-controls">
    <div class="clndr-control-button clndr-previous-button" (click)="previous()" role="button">‹</div>

    <div class="clndr-control-button month fw-bold">{{ heading }}</div>

    <div class="clndr-control-button clndr-next-button" (click)="next()" role="button">›</div>
  </div>

  <div class="clndr-grid">
    @for (month of calendar.months; track month) {
      <div class="month" [ngStyle]="style">
        <div class="month-content">
          <div class="month-header">{{ month.month | portalDate: 'MMMM' }}</div>
          <div class="days-of-the-week">
            @for (headerDay of calendar.daysOfTheWeek; track headerDay) {
              <div class="header-day">
                {{ 'calendar.day.' + headerDay | translate }}
              </div>
            }
          </div>
          <div class="days">
            @for (day of month.days; track day) {
              <div [class]="day.classes">
                <ng-template #defaultTemplate>
                  @if (day.events.length === 0) {
                    <span class="calendar__day" (click)="create(day)" role="button">
                      {{ day.day }}
                    </span>
                  }
                  @if (day.events.length > 0) {
                    <span class="calendar__day" [portalTippy]="day.events[0].title">
                      {{ day.day }}
                    </span>
                  }
                </ng-template>
                <ng-container
                  *ngTemplateOutlet="
                    dayTemplate ? dayTemplate : defaultTemplate;
                    context: { $implicit: day, event: day.events[0] }
                  "
                ></ng-container>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
